import {
  SF85, SF85P, SF85PS, SF86, SF852013, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D
} from 'constants/formTypes';
import SignatureValidator from './signature';

export const hideHippa = (store = {}) => !(shouldShowHipaaPsych(store) || shouldShowHipaaSubstance(store));

export const shouldShowHipaaPsych = (store = {}) => {
  const psych = store.Psychological;
  const flagged = (question) => question?.value === 'Yes';

  const tests = [
    psych?.Competence?.IsIncompetent,
    psych?.Consultations?.Consulted,
    psych?.Diagnoses?.Diagnosed,
    psych?.Hospitalizations?.Hospitalized,
    psych?.ExistingConditions?.HasCondition,
  ];

  const showHipaa = tests.some((x) => flagged(x));
  return showHipaa;
};

export const shouldShowHipaaSubstance = (store = {}) => {
  const substance = store.Substance;
  const flagged = (question) => question?.value === 'Yes';

  const tests = [
    substance?.OrderedTreatments?.TreatmentOrdered,
    substance?.VoluntaryTreatments?.TreatmentVoluntary,
    substance?.OrderedCounselings?.HasBeenOrdered,
    substance?.VoluntaryCounselings?.SoughtTreatment,
    substance?.AlcoholCounselings?.AlcoholTreatmentOrCounselingAnswer,
  ];

  const showHipaa = tests.some((x) => flagged(x));
  return showHipaa;
};

export const hipaaIsSigned = (signatures = {}, formType) => ([SF86, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D].includes(formType) ? new SignatureValidator(signatures.Medical).isValid() : true);

export const formIsSigned = (signatures = {}, showHipaaPsych, formType) => {
  const general = [SF85, SF85P, SF85PS, SF86, SF852013, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D].includes(formType) ? new SignatureValidator(signatures.General).isValid() : true;
  const credit = [SF86, SF85, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D].includes(formType) ? new SignatureValidator(signatures.Credit).isValid() : true;
  // Only check for medical signature if it is being shown for the Psychological section
  const medical = showHipaaPsych ? hipaaIsSigned(signatures, formType) : true;

  return (
    new SignatureValidator(signatures.AdditionalComments).isValid()
    && general
    && credit
    && medical
  );
};
